define('commons/auto-diagnosis-faults-tree',['jquery', 'commons/config-tree'], function($, ConfigTree) {
    // INSTALL DATA TREE
    var AutoDiagnosisFaultsTree = function(args) {
        ConfigTree.apply(this, [args]);
        this.tree.fancytree(this.settings);
    };

    for ( var element in ConfigTree.prototype) {
        AutoDiagnosisFaultsTree.prototype[element] = ConfigTree.prototype[element];
    }

    AutoDiagnosisFaultsTree.prototype.createTitle = function(data, id) {
        var cls = "hwtree-default-icon";
        if (data.score > 0 && data.isRoot){
            cls += " hwtree-status-failed";
        } else if (data.isRoot) {
            cls += " hwtree-status-passed";
        }
        var title = '<span class="' + cls + '">';
        title += data.value + " : <b>" + data.score + "</b>";
        title += '</span>';
        return title;
    };

    AutoDiagnosisFaultsTree.prototype.createNode = function(parent, data, id, title, selected) {
        var element = data.value;
        if (data.array){
            title = element;
        }
        return parent.addChildren({
            title : title,
            icons: false,
            selected : true,
            field : data.id,
            value : data.value,
            array : data.array,
            key : id,
            active : selected
        });
    };

    AutoDiagnosisFaultsTree.prototype.expandAll= function(){
        this.tree.fancytree("getRootNode").visit(function(node){
            node.setExpanded(true);
        });
    };

    AutoDiagnosisFaultsTree.toFancyFormat = function(faultTypes, testTypes, diagnosis) {
        children = [];
        $.each(faultTypes, function (section, faultType){
            var fault = diagnosis.results[faultType.value];
            var nodeConfig = {};
            nodeConfig.id = faultType.code;
            nodeConfig.text = faultType.name;
            nodeConfig.value = faultType.name;
            nodeConfig.isRoot = true;
            if (fault != null) {
                nodeConfig.score = fault.score;
                nodeConfig.children = AutoDiagnosisFaultsTree.createFancyChilds(section, fault, testTypes);
            } else {
                nodeConfig.score = 0;
            }
            children.push(nodeConfig);
        });
        children = children.sort(function(a, b){
            if (a.score > b.score){
                return -1;
            } else if (a.score < b.score){
                return 1;
            } if (a.value.toLowerCase() < b.value.toLowerCase()){
                return -1;
            } else if (a.value.toLowerCase() > b.value.toLowerCase()){
                return 1;
            } else {
                return 0;
            }
        });
        return {children : children};
    };

    AutoDiagnosisFaultsTree.createFancyChilds = function(parent, fault, testTypes, isArray, onlyTest, parentIsTest) {
        var children = [];
        var testTypesByCode = {};
        $.each(testTypes, function(i, testType) {
            testTypesByCode[testType.code] = testType;
        });
        $.each(fault.failedTests, function (section, test){
            var testType = testTypesByCode[test.type];
            var node = {};
            node.id = section;
            node.value = testType.name;
            node.field = section;
            node.score = test.score;
            children.push(node);
        });
        return children;
    };
    return AutoDiagnosisFaultsTree;
});
